<!--
수기과금 모달 컴포넌트
------------------------------------
사용: app.$refs['manual-charge'].form(userId)
패턴: set-restrict-register.vue 참조
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical" style="width: 640px">

            <div class="uk-modal-header">
                <h4 class="uk-text-center" style="margin: 0;" v-text="isRefund ? '수기환불' : '수기과금'"></h4>
            </div>

            <div class="uk-modal-body" style="padding: 24px 30px;">

                <!-- 과금방식 토글 -->
                <div style="display: flex; border-radius: 10px; overflow: hidden; margin-bottom: 24px; border: 2px solid #e2e8f0;">
                    <button type="button"
                            :style="{
                                flex: '1',
                                padding: '11px 0',
                                border: 'none',
                                cursor: 'pointer',
                                fontWeight: '600',
                                background: !isRefund ? '#1e87f0' : '#fff',
                                color: !isRefund ? '#fff' : '#a0aec0',
                                transition: 'all 0.15s ease'
                            }"
                            @click="inputs.charge_type = '1'">
                        과금
                    </button>
                    <button type="button"
                            :style="{
                                flex: '1',
                                padding: '11px 0',
                                border: 'none',
                                borderLeft: '2px solid #e2e8f0',
                                cursor: 'pointer',
                                fontWeight: '600',
                                background: isRefund ? '#c53030' : '#fff',
                                color: isRefund ? '#fff' : '#a0aec0',
                                transition: 'all 0.15s ease'
                            }"
                            @click="inputs.charge_type = '2'">
                        환불
                    </button>
                </div>

                <!-- 환불 안내 -->
                <div v-if="isRefund"
                     style="background: #fff5f5; border: 1px solid #feb2b2; border-radius: 8px; padding: 12px 16px; margin-bottom: 20px; color: #742a2a; line-height: 1.6;">
                    환불은 결제수단에 관계없이 <strong>예치금 입금</strong>으로 처리됩니다.
                </div>

                <!-- 회원 정보 카드 -->
                <div v-if="member.nick"
                     style="background: #f8fafc; border: 1px solid #edf2f7; border-radius: 10px; padding: 18px 20px; margin-bottom: 24px;">
                    <div style="font-weight: 600; color: #718096; margin-bottom: 14px; padding-bottom: 10px; border-bottom: 1px solid #edf2f7;">
                        회원 정보
                    </div>
                    <div class="uk-grid uk-grid-small uk-child-width-1-2" uk-grid>
                        <div>
                            <app-column header="회원사" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                {{ member.nick }}
                            </app-column>
                        </div>
                        <div>
                            <app-column header="이메일" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                {{ member.email }}
                            </app-column>
                        </div>
                        <div>
                            <app-column header="사서함" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                {{ member.mailbox || '미설정' }}
                            </app-column>
                        </div>
                        <div>
                            <app-column header="결제수단" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                <span v-if="isRefund" style="display: inline-flex; align-items: center; gap: 6px; background: #fff5f5; border: 1px solid #feb2b2; border-radius: 6px; padding: 2px 10px; font-size: 0.9rem;">
                                    <span style="width: 7px; height: 7px; border-radius: 50%; background: #e53e3e; flex-shrink: 0;"></span>
                                    <span>예치금 (환불)</span>
                                </span>
                                <span v-else style="display: inline-flex; align-items: center; gap: 6px; background: #f7fafc; border: 1px solid #e2e8f0; border-radius: 6px; padding: 2px 10px; font-size: 0.9rem;">
                                    <span style="width: 7px; height: 7px; border-radius: 50%; background: #48bb78; flex-shrink: 0;"></span>
                                    <span v-text="member.pm_label"></span>
                                </span>
                            </app-column>
                        </div>
                    </div>
                </div>

                <!-- 과금 정보 섹션 헤더 -->
                <div style="font-weight: 600; color: #4a5568; margin-bottom: 16px; padding-bottom: 10px; border-bottom: 2px solid #edf2f7;">
                    <span v-text="isRefund ? '환불 정보' : '과금 정보'"></span>
                </div>

                <!-- 금액 -->
                <div class="uk-margin">
                    <label class="uk-form-label" v-text="isRefund ? '환불 금액 (원)' : '과금 금액 (원)'"></label>
                    <div class="uk-form-controls">
                        <input class="uk-input" type="text"
                               v-model="inputs.amount"
                               @input="onAmountInput"
                               placeholder="최소 1원">
                    </div>
                </div>

                <!-- 사유 -->
                <div class="uk-margin">
                    <label class="uk-form-label" v-text="isRefund ? '환불 사유' : '과금 사유'"></label>
                    <div class="uk-form-controls">
                        <textarea class="uk-textarea" rows="3"
                                  v-model="inputs.memo"
                                  :placeholder="(isRefund ? '환불' : '과금') + ' 사유를 입력하세요 (최대 500자)'"></textarea>
                    </div>
                </div>

                <!-- 결제/환불 요약 -->
                <div v-if="amount > 0"
                     style="border-radius: 10px; padding: 18px 20px; margin-top: 20px; border: 1px solid #e2e8f0;"
                     :style="{ background: isRefund ? '#fff5f5' : '#f7fafc' }">
                    <div style="font-weight: 600; margin-bottom: 14px; padding-bottom: 10px; border-bottom: 1px solid #e2e8f0;">
                        <span v-text="isRefund ? '환불 요약' : '결제 요약'"></span>
                    </div>
                    <div class="uk-flex uk-flex-between" style="padding: 6px 0; color: #718096;">
                        <span v-text="isRefund ? '환불금액' : '기본과금액'"></span>
                        <span style="color: #2d3748; font-weight: 500;">{{ numberFormat(amount) }} 원</span>
                    </div>
                    <div v-if="isCard && !isRefund" class="uk-flex uk-flex-between" style="padding: 6px 0; color: #718096;">
                        <span>카드수수료 ({{ feeRatePercent }}%)</span>
                        <span style="color: #2d3748; font-weight: 500;">{{ numberFormat(feeAmount) }} 원</span>
                    </div>
                    <div v-if="isCard && !isRefund" class="uk-flex uk-flex-between" style="padding: 6px 0; color: #718096;">
                        <span>카드수수료 부가세</span>
                        <span style="color: #2d3748; font-weight: 500;">{{ numberFormat(feeVatAmount) }} 원</span>
                    </div>
                    <div class="uk-flex uk-flex-between"
                         :style="{
                             borderTop: '2px solid ' + (isRefund ? '#feb2b2' : '#bee3f8'),
                             marginTop: '10px',
                             paddingTop: '12px',
                             fontWeight: '700',
                             fontSize: '1.1rem'
                         }">
                        <span v-text="isRefund ? '최종 환불금액' : '최종 결제금액'"></span>
                        <span :style="{ color: isRefund ? '#c53030' : '#1e87f0' }">{{ numberFormat(totalAmount) }} 원</span>
                    </div>
                </div>

                <!-- 카드수수료 안내 (과금 + 카드일 때만) -->
                <div v-if="isCard && !isRefund && amount > 0"
                     style="background: #fffbeb; border: 1px solid #f6e05e; border-radius: 8px; padding: 12px 16px; margin-top: 12px; color: #744210; line-height: 1.6;">
                    <span style="font-weight: 600;">카드수수료 안내</span> &mdash;
                    수기과금의 카드수수료에는 부가세(10%)가 별도 부과됩니다.
                </div>

                <!-- 에러 메시지 -->
                <div v-if="errorMsg" class="uk-alert uk-alert-danger" style="margin-top: 16px;">
                    {{ errorMsg }}
                </div>

                <!-- 안내 패널 (하단, 접기/펼치기) -->
                <div style="margin-top: 24px; border-top: 1px dashed #e2e8f0; padding-top: 16px;">
                    <div class="uk-flex uk-flex-between uk-flex-middle">
                        <span style="font-weight: 500; color: #a0aec0;">수기과금 안내</span>
                        <button type="button" class="uk-button uk-button-text uk-button-small"
                                @click="showInfo = !showInfo"
                                v-text="showInfo ? '접기' : '펼치기'"></button>
                    </div>
                    <div v-show="showInfo" style="margin-top: 12px; padding: 14px 16px; background: #f7fafc; border-radius: 8px;">
                        <p style="color: #4a5568; line-height: 1.7; margin: 0 0 12px 0;">
                            모든 과금은 등록된 결제수단으로 즉시 결제 처리됩니다.
                        </p>
                        <ul class="uk-list" style="color: #4a5568; margin: 0;">
                            <li><span style="font-weight: 600;">추가비용</span> — 상품에 귀속되는 비용</li>
                            <li><span style="font-weight: 600;">기타운임</span> — 배송(하우스)에 귀속되는 비용</li>
                            <li><span style="font-weight: 600;">수기과금</span> — 특정 배송/상품과 무관한 임의 비용</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="uk-modal-footer uk-text-right">
                <button type="button"
                        class="uk-button uk-button-default uk-modal-close">
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button type="button"
                        class="uk-button"
                        :style="{
                            background: isRefund ? '#c53030' : '#1e87f0',
                            color: '#fff',
                            border: '1px solid ' + (isRefund ? '#c53030' : '#1e87f0')
                        }"
                        :disabled="submitting"
                        @click="submit()">
                    <span uk-icon="icon: check"></span>
                    {{ isRefund ? '환불 실행' : '과금 실행' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            csrfToken: String,
            cardFeeRate: { type: Number, default: 0.035 },
        },
        data: function () {
            return {
                showInfo: false,
                member: {},
                userId: null,
                inputs: {
                    charge_type: '1',
                    amount: '',
                    memo: '',
                },
                amount: 0,
                errorMsg: '',
                submitting: false,
            };
        },
        computed: {
            isCard: function () {
                return this.member.is_card || false;
            },
            isRefund: function () {
                return this.inputs.charge_type === '2';
            },
            feeRatePercent: function () {
                return parseFloat((this.cardFeeRate * 100).toFixed(2));
            },
            feeAmount: function () {
                // 환불 시 카드수수료 없음 (예치금 환불 고정)
                if (this.isRefund) return 0;
                return this.isCard ? Math.floor(this.amount * this.cardFeeRate) : 0;
            },
            feeVatAmount: function () {
                return this.isCard ? Math.floor(this.feeAmount * 0.1) : 0;
            },
            totalAmount: function () {
                return this.amount + this.feeAmount + this.feeVatAmount;
            },
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm: function () {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼 — 외부에서 호출
             * @param {Number} user_id 회원 ID
             */
            form: function (user_id) {
                // 입력값 초기화
                this.userId = user_id;
                this.inputs = { charge_type: '1', amount: '', memo: '' };
                this.amount = 0;
                this.member = {};
                this.errorMsg = '';
                this.submitting = false;

                // 회원 기본 정보 로드
                var self = this;
                var loadUser = new Promise(function (resolve) {
                    $.app.ajax.module.background({
                        type: 'get',
                        url: '/company-users/' + user_id,
                        contentType: 'application/json',
                        data: {},
                        success: function (response) {
                            resolve(response);
                        },
                    });
                });

                // 결제수단 정보 로드
                var loadMemberData = new Promise(function (resolve) {
                    $.app.ajax.module.background({
                        type: 'get',
                        url: '/admin/billings/manual-charge/member-data/' + user_id,
                        contentType: 'application/json',
                        data: {},
                        success: function (response) {
                            resolve(response);
                        },
                    });
                });

                // 두 요청 완료 후 모달 표시
                Promise.all([loadUser, loadMemberData]).then(function (results) {
                    var userResponse = results[0];
                    var memberData = results[1];

                    self.member = {
                        nick: userResponse.user.nick,
                        email: userResponse.user.email,
                        mailbox: memberData.mailbox,
                        pm_type: memberData.pm_type,
                        pm_label: memberData.pm_label,
                        is_card: memberData.is_card,
                    };

                    self.displayForm();
                });
            },

            /**
             * 금액 입력 핸들러
             */
            onAmountInput: function () {
                this.amount = parseInt(this.inputs.amount) || 0;
            },

            /**
             * submit
             */
            submit: function () {
                // 클라이언트 검증
                if (this.amount < 1) {
                    this.errorMsg = (this.isRefund ? '환불' : '과금') + ' 금액은 최소 1원 이상이어야 합니다.';
                    return;
                }
                if (!this.inputs.memo || !this.inputs.memo.trim()) {
                    this.errorMsg = (this.isRefund ? '환불' : '과금') + ' 사유를 입력하세요.';
                    return;
                }

                this.errorMsg = '';
                this.submitting = true;

                var self = this;
                var load = new Promise(function (resolve, reject) {
                    $.app.ajax.module.default({
                        type: 'post',
                        url: '/admin/billings/manual-charge',
                        data: {
                            '_token': self.csrfToken,
                            'user_id': self.userId,
                            'charge_type': self.inputs.charge_type,
                            'amount': self.inputs.amount,
                            'memo': self.inputs.memo,
                        },
                        success: function (response) {
                            resolve(response);
                        },
                        error: function (jqXHR) {
                            reject(jqXHR);
                        },
                    });
                });

                load.then(function (response) {
                    // 모달 닫기
                    UIkit.modal(self.$el).hide();

                    // 결과 메시지 표시 후 새로고침
                    UIkit.modal.alert(response.msg).then(function () {
                        $.app.refresh();
                    });
                }).catch(function (jqXHR) {
                    self.submitting = false;

                    if (jqXHR.status === 422 && jqXHR.responseJSON) {
                        // validation 에러
                        var errors = jqXHR.responseJSON;
                        var msgs = [];
                        for (var field in errors) {
                            if (Array.isArray(errors[field])) {
                                msgs.push(errors[field][0]);
                            }
                        }
                        self.errorMsg = msgs.join('\n') || '입력값을 확인하세요.';
                    } else if (jqXHR.responseJSON && jqXHR.responseJSON.msg) {
                        self.errorMsg = jqXHR.responseJSON.msg;
                    } else {
                        self.errorMsg = '요청 처리 중 오류가 발생했습니다.';
                    }
                });
            },

            /**
             * 숫자 포맷
             */
            numberFormat: function (num) {
                return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
        },
    };
</script>
